// extracted by mini-css-extract-plugin
export default {"title":"address_form__title__rk5Jr","footnoteMsgs":"address_form__footnoteMsgs__PeUNZ","footnoteMsg":"address_form__footnoteMsg__rlMZn"};